export default {
  EmAnos: {
    label: 'fields.engineering.isolation-aging.in-years',
  },
  EmPercentual: {
    label: 'fields.engineering.isolation-aging.in-percentage',
  },
  ClasseDeElevacao: {
    label: 'fields.asset.transformer.temperature-elevation-class',
  },
  TipoPapelIsolante: {
    label: 'fields.asset.transformer.type-of-insulating-paper',
  },
  PeriodoFixo: {
    label: 'engineering.isolation-aging.parameters.fixed-period',
  },
  HoraInicial: {
    label: 'engineering.isolation-aging.parameters.initial-hour',
  },
  HoraFinal: {
    label: 'engineering.isolation-aging.parameters.final-hour',
  },
  DataInicial: {
    label: 'engineering.isolation-aging.parameters.initial-date',
  },
  DataFinal: {
    label: 'engineering.isolation-aging.parameters.final-date',
  },
  PeriodoMovel: {
    label: 'engineering.isolation-aging.parameters.moving-period',
  },
  Dias: {
    label: 'engineering.isolation-aging.parameters.days',
    precision: 0,
  },
  ConsiderarUmidade: {
    label: 'engineering.isolation-aging.parameters.consider-humidity',
  },
  FonteUmidadePapel: {
    label: 'engineering.isolation-aging.parameters.paper-humidity-source',
  },
  UmidadePapel: {
    label: 'engineering.isolation-aging.parameters.paper-humidity',
    precision: 1,
  },
  UmidadeReferencia: {
    label: 'engineering.isolation-aging.parameters.reference-humidity',
  },
  PorcentagemUmidadeReferencia: {
    label: 'engineering.isolation-aging.parameters.reference-humidity-percentage',
    precision: 1,
  },
  MetodoParaCurvaUmidade: {
    label: 'engineering.isolation-aging.parameters.humidity-curve-method',
  },
  ExpectativaVidaTotalAtivoEmAnos: {
    label: 'engineering.isolation-aging.parameters.total-asset-life-expectancy-in-years',
    precision: 0,
  },
  OxigenioOleo: {
    label: 'engineering.isolation-aging.parameters.oxygen-oil',
    precision: 1,
  },
};
